// The lone real location slot (the blank " " option is ignored), or null
// unless there is exactly one.
export const getSingleLocation = (locations = []) => {
  const realLocations = locations.filter(({ slot }) => (slot ?? "").trim() !== "");
  return realLocations.length === 1 ? realLocations[0].slot : null;
};

// Pre-fills the single real location on rows that have none, leaving rows that
// already have a location untouched. Returns the original array when no default
// applies, so referential equality is preserved for memoization.
export const applyDefaultLocation = (rows, locations) => {
  const singleLocation = getSingleLocation(locations);
  if (!singleLocation) return rows;
  return rows.map((row) =>
    (row.pulloutLocation ?? "").trim() === ""
      ? { ...row, pulloutLocation: singleLocation }
      : row,
  );
};
